import React from 'react';
import './TrainerProfiles.css';
import jay from '../../assets/images/trainers/jay.jpg';
import nicholas from '../../assets/images/trainers/nicholas.jpg';
import christine from '../../assets/images/trainers/christine.jpg';
import jack from '../../assets/images/trainers/jack.jpg';
import archi from '../../assets/images/trainers/archi.jpg';

interface Achievement {
  text: string;
  highlight?: boolean;
}

interface Trainer {
  id: number;
  name: string;
  nameEn: string;
  achievements: Achievement[];
  imageUrl: string;
}

const TrainerProfiles: React.FC = () => {
  const trainers: Trainer[] = [
    {
      id: 1,
      name: "Jay Cheung",
      nameEn: "Jay Cheung",
      achievements: [
        { text: "JSW Studio 創辦人" },
        { text: "澳洲 Calisthenics Certification Level 4 coach" },
        { text: "英國 REPS 認可街頭健身教練" },
        { text: "2023 香港街頭健身錦標賽 冠軍" },
        { text: "2023 街頭健身世界錦標賽 男子排名14" }
      ],
      imageUrl: jay
    },
    {
      id: 2,
      name: "Nicholas Wong",
      nameEn: "Nicholas Wong",
      achievements: [
        { text: "2025 街頭健身世界錦標賽 男子資深組排名第6" },
        { text: "2018 街頭健身世界盃（澳洲站） 冠軍" },
        { text: "2017 香港街頭健身錦標賽 冠軍" },
        { text: "2016 街頭健身世界盃決賽 第四名" },
        { text: "2016 香港街頭健身錦標賽 冠軍" },
        { text: "2015 香港街頭健身錦標賽 冠軍" }
      ],
      imageUrl: nicholas
    },
    {
      id: 3,
      name: "Christine Kwan",
      nameEn: "Christine Kwan",
      achievements: [
        { text: "2025 街頭健身世界錦標賽 女子中量級排名第5" },
        { text: "2024 港澳街頭健身錦標賽女子公開組 冠軍" },
        { text: "2023 香港街頭健身錦標賽女子公開組 亞軍" },
        { text: "2023 街頭健身世界錦標賽 女子排名第7" }
      ],
      imageUrl: christine
    },
    {
      id: 4,
      name: "Jack Mo",
      nameEn: "Jack Mo",
      achievements: [
        { text: "aasfp x WSWCF 國際街頭健身及徒手訓練專家證書" },
        { text: "WSWCF 國際街頭健身及徒手訓練教練證書" },
        { text: "2024 港澳街頭健身錦標賽男子公開組 冠軍" },
        { text: "2023 澳門黑金盃街頭健身挑戰 第四名" },
        { text: "2016 阿諾國際體育節(亞洲站)街頭健身比賽 亞軍" }
      ],
      imageUrl: jack
    },
    {
      id: 5,
      name: "Ar Chi",
      nameEn: "Ar Chi",
      achievements: [
        { text: "NASM CPT 認可教練證書" },
        { text: "2024 ANBC 亞洲自然健美協會比賽" },
        { text: "古典組 新秀第二名 公開組第四名" }
      ],
      imageUrl: archi
    }
  ];

  // First row: Jay, Nicholas, Christine
  const firstRowTrainers = trainers.slice(0, 3);
  // Second row: Jack, Ar Chi
  const secondRowTrainers = trainers.slice(3);

  return (
    <section id="trainers" className="trainers-section section">
      <div className="container">
        <h2 className="section-title">教練介紹</h2>
        
        <div className="trainers-grid">
          {/* First Row */}
          {firstRowTrainers.map(trainer => (
            <div key={trainer.id} className="trainer-card">
              <div className="trainer-image-container">
                <img 
                  src={trainer.imageUrl}
                  alt={trainer.name}
                  className="trainer-image"
                />
              </div>
              <div className="trainer-info">
                <h3 className="trainer-name">{trainer.name}</h3>
                <ul className="trainer-achievements">
                  {trainer.achievements.map((achievement, index) => (
                    <li 
                      key={index} 
                      className={achievement.highlight ? 'highlight' : ''}
                    >
                      {achievement.text}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
        
        <div className="trainers-grid">
          {/* Second Row */}
          {secondRowTrainers.map(trainer => (
            <div key={trainer.id} className="trainer-card">
              <div className="trainer-image-container">
                <img 
                  src={trainer.imageUrl}
                  alt={trainer.name}
                  className="trainer-image"
                />
              </div>
              <div className="trainer-info">
                <h3 className="trainer-name">{trainer.name}</h3>
                <ul className="trainer-achievements">
                  {trainer.achievements.map((achievement, index) => (
                    <li 
                      key={index} 
                      className={achievement.highlight ? 'highlight' : ''}
                    >
                      {achievement.text}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrainerProfiles;
